const comments = [
  {
    name: '追剧达人小王',
    text: '大师兄影视真的良心！画质清晰不说，关键是没有任何广告，比那些动不动就弹广告的网站好用太多了。庆余年2全集上线那天我就守着看了，加载速度真的快，秒开！推荐给了好多朋友。',
    date: '3天前',
  },
  {
    name: '电影爱好者老李',
    text: '作为一个阅片无数的老影迷，大师兄影视的片库深度让我惊喜。很多冷门高分电影在这里都能找到，而且都是高清版本。投屏到电视上看效果也很棒，已经彻底抛弃其他平台了。',
    date: '5天前',
  },
  {
    name: '学生党小陈',
    text: '免费的在线看剧平台里，大师兄影视是体验最好的。宿舍网速一般，但选高清画质也能流畅播放，不卡顿这一点真的强。而且剧集更新很及时，追剧日历功能也很实用。',
    date: '1周前',
  },
  {
    name: '影视博主阿飞',
    text: '做影视解说两年了，大师兄影视是我日常找素材的首选平台。片源质量稳定，更新速度快，分类做得也很清晰。特别是纪录片专区，很多优质内容在别处都找不到。强烈推荐！',
    date: '1周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">用户评价</h2>
          <p className="text-sm md:text-base text-foreground-600">来自真实用户的观影体验分享。</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {comments.map((item, i) => (
            <div
              key={i}
              className="rounded-2xl bg-background-50 border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-primary-600">{item.name.charAt(0)}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-bold text-foreground-900">{item.name}</h3>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {[...Array(5)].map((_, j) => (
                      <i key={j} className="ri-star-fill text-xs text-amber-400 w-3 h-3 flex items-center justify-center"></i>
                    ))}
                  </div>
                </div>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}